module.exports = __webpack_public_path__ + "img/icon-empty-cart.e348b3a.png";